import {useSelector} from "react-redux";

const useDistricts = () => {
    return useSelector(state => state.districts)
}
export default useDistricts